import {Actions} from "../actions/login.action";

export interface FirebaseResponse {
    type: string;
    response: {
        code: string;
        message: string;
        hints?: Array<{ uid: string; displayName: string; factorId: string; enrollmentTime: string }>;
        verificationId?: string;
    }
}

export interface MfaState {
    enrolling: boolean;
    verifying: boolean;
    challenging: boolean;
    verificationId: string;
    error: string;
    enrolled: boolean;
}

export interface LoginState {
    isLoggedIn: boolean;
    loading: boolean;
    firebaseResponse: FirebaseResponse;
    email: string;
    mfa: MfaState;
}

const defaultFirebaseResponse = {
    type: "",
    response: {
        code: "",
        message: "",
    },
};
const defaultMfaState: MfaState = {
    enrolling: false,
    verifying: false,
    challenging: false,
    verificationId: "",
    error: "",
    enrolled: false,
};
const defaultState: LoginState = {
    isLoggedIn: false,
    loading: false,
    firebaseResponse: defaultFirebaseResponse,
    email: "",
    mfa: defaultMfaState,
};

export default function LoginStateReducer(state = defaultState, action: any) : LoginState {
    switch (action.type) {
        case Actions.FIREBASE_LOGIN:
            return {
                ...state,
                loading: true,
                firebaseResponse: defaultFirebaseResponse,
                mfa: defaultMfaState,
            };
        case `${Actions.FIREBASE_LOGIN}_SUCCESS`:
            return {
                ...state,
                loading: false,
                isLoggedIn: true,
                firebaseResponse: defaultFirebaseResponse,
                mfa: { ...defaultMfaState, enrolled: true },
            };
        case `${Actions.FIREBASE_LOGIN}_FAILURE`:
            return {
                ...state,
                loading: false,
                isLoggedIn: false,
                firebaseResponse: {
                    type: "FAILURE",
                    response: action.payload.response,
                },
            };
        case `${Actions.FIREBASE_LOGIN}_MFA_REQUIRED`:
            return {
                ...state,
                loading: false,
                firebaseResponse: {
                    type: "MFA_REQUIRED",
                    response: action.payload.response,
                },
                mfa: defaultMfaState,
            };
        case Actions.CLEARE_FIREBASE_RESPONSE:
            return {
                ...state,
                firebaseResponse: defaultFirebaseResponse,
            };
        case Actions.FIREBASE_REGISTER:
            return {
                ...state,
                loading: true,
                firebaseResponse: defaultFirebaseResponse,
            };
        case `${Actions.FIREBASE_REGISTER}_FAILURE`:
            return {
                ...state,
                loading: false,
                firebaseResponse: {
                    type: "FAILURE",
                    response: action.payload.response,
                },
            };
        case `${Actions.FIREBASE_REGISTER}_SUCCESS`:
            return {
                ...state,
                loading: false,
                firebaseResponse: {
                    type: "SUCCESS",
                    response: {
                        code: "",
                        message: "You have successfully signed up!",
                    },
                },
            };
        case Actions.FIREBASE_VERIFICATION_MAIL:
            return {
                ...state,
                loading: true,
                firebaseResponse: defaultFirebaseResponse,
            }
        case `${Actions.FIREBASE_VERIFICATION_MAIL}_SUCCESS`:
            return {
                ...state,
                loading: false,
                firebaseResponse: {
                    type: "SUCCESS",
                    response: {
                        code: "",
                        message: "A verification mail has been sent to your email id. Please click on that link and verify your login",
                    },
                },
            };
        case `${Actions.FIREBASE_VERIFICATION_MAIL}_FAILURE`:
            return {
                ...state,
                loading: false,
                firebaseResponse: {
                    type: "FAILURE",
                    response: {
                        code: "",
                        message: action.payload.response.message,
                    },
                },
            };
        case Actions.STOP_LOADING:
            return {
                ...state,
                loading: false,
            };
        case Actions.FIREBASE_PASSWORD_UPDATE:
            return {
                ...state,
                loading: true,
            };
        case `${Actions.FIREBASE_PASSWORD_UPDATE}_SUCCESS`:
            return {
                ...state,
                loading: false,
            };
         case `${Actions.FIREBASE_PASSWORD_UPDATE}_FAILURE`:
            return {
                ...state,
                loading: false,
            };
        case Actions.MFA_ENROLL:
            return {
                ...state,
                mfa: { ...state.mfa, enrolling: true, error: "" },
            };
        case `${Actions.MFA_ENROLL}_CODE_SENT`:
            return {
                ...state,
                mfa: {
                    ...state.mfa,
                    enrolling: false,
                    verificationId: action.payload.response.verificationId,
                },
            };
        case `${Actions.MFA_ENROLL}_FAILURE`:
            return {
                ...state,
                mfa: {
                    ...state.mfa,
                    enrolling: false,
                    error: action.payload.response?.message || "MFA enrollment failed",
                },
            };
        case Actions.MFA_CHALLENGE:
            return {
                ...state,
                mfa: { ...state.mfa, challenging: true, error: "" },
            };
        case `${Actions.MFA_CHALLENGE}_CODE_SENT`:
            return {
                ...state,
                mfa: {
                    ...state.mfa,
                    challenging: false,
                    verificationId: action.payload.response.verificationId,
                },
            };
        case `${Actions.MFA_CHALLENGE}_FAILURE`:
            return {
                ...state,
                mfa: {
                    ...state.mfa,
                    challenging: false,
                    error: action.payload.response?.message || "MFA challenge failed",
                },
            };
        case Actions.MFA_VERIFY:
            return {
                ...state,
                mfa: { ...state.mfa, verifying: true, error: "" },
            };
        case `${Actions.MFA_VERIFY}_SUCCESS`:
            return {
                ...state,
                mfa: { ...defaultMfaState, enrolled: true },
                isLoggedIn: true,
                loading: false,
                firebaseResponse: defaultFirebaseResponse,
            };
        case `${Actions.MFA_VERIFY}_FAILURE`:
            return {
                ...state,
                mfa: {
                    ...state.mfa,
                    verifying: false,
                    error: action.payload.response?.message || "MFA verification failed",
                },
            };
        case Actions.MFA_ENROLLMENT_REQUIRED:
            return {
                ...state,
                loading: false,
                firebaseResponse: {
                    type: "MFA_ENROLLMENT_REQUIRED",
                    response: { message: "MFA enrollment required", code: "" },
                },
            };
        default:
            return state
    }
}